var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"custom-select",attrs:{"reduce":val => val.uid,"label":"name","options":_vm.sections},model:{value:(_vm.valueMutated),callback:function ($$v) {_vm.valueMutated=$$v},expression:"valueMutated"}})
}
var staticRenderFns = []

export { render, staticRenderFns }